import React, { Component } from 'react';

import DropdownList from '../utils/DropdownList';
import { getTitoliOptions } from '../../form-helpers';

export default class SelectTitoli extends Component {
    state = {
        items: [],
        isFetching: true
    };

    componentDidMount() {
        getTitoliOptions().then(options => {
            this.setState({
                items: options,
                isFetching: false
            });
        });
    }

    render() {
        const { items, isFetching } = this.state;

        return (
            <DropdownList
                items={items}
                isLoading={isFetching}
                {...this.props}
            />
        );
    }
}
